import React, { Component } from 'react'
import { Link, useHistory } from 'react-router-dom';
import ajax from '../utils/ajax'
import functions from '../utils/functions';

class Home extends Component {


    state = {
        screen: "Login",
        loggedIn: true,
        // accessInfo: functions.permissionGuard()
    }

    render() {
        return (


            <body>

                {/* <!-- Preloader Start --> */}
                {/* <div class="preloader">
        <div class="loading-container">
            <div class="loading"></div>
            <div id="loading-icon"><img src="images/loader.svg" alt=""/></div>
        </div>
    </div> */}
                {/* <!-- Preloader End --> */}

                {/* <!-- Header Start --> */}
                <header class="main-header">
                    <div class="header-sticky">
                        <nav class="navbar navbar-expand-lg">
                            <div class="container">
                                {/* <!-- Logo Start --> */}
                                <a class="navbar-brand" href="/">
                                    <img src="assets/images/logo512.png" style={{ height: '60px' }} alt="Logo" />
                                </a>
                                {/* <!-- Logo End --> */}
                                <div class="navbar-toggle"></div>
                            </div>
                        </nav>
                        <div class="responsive-menu"></div>
                    </div>
                </header>
                {/* <!-- Header End --> */}

                {/* <!-- Page Header Start --> */}
                <div class="page-header" style={{ height: '30px' }}>
                    {/* <!-- Grid Lines Start --> */}
                    <div class="grid-lines">
                        <div class="grid-line-1"></div>
                        <div class="grid-line-2"></div>
                        <div class="grid-line-3"></div>
                        <div class="grid-line-4"></div>
                        <div class="grid-line-5"></div>
                    </div>
                    {/* <!-- Grid Lines End --> */}
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-12">
                                {/* <!-- Page Header Box Start --> */}
                                <div class="page-header-box">
                                    <h1 class="wow fadeInUp" data-cursor="-opaque">Privacy <span style={{ WebkitBackgroundClip: 'text' }}>Policy</span></h1>
                                </div>
                                {/* <!-- Page Header Box End --> */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Page Header End --> */}

                {/* <!-- Page Faqs Start --> */}
                <div class="page-faqs">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-4">
                                {/* <!-- Page Single Sidebar Start --> */}
                                <div class="page-single-sidebar">
                                    {/* <!-- Page Category List Start --> */}
                                    <div class="page-catagory-list wow fadeInUp">
                                        <ul>
                                            <li><a href="#priv1">Background</a></li>
                                            <li><a href="#priv2">What Does This Policy Cover</a></li>
                                            <li><a href="#priv3">What Data Do We Collect</a></li>

                                            <li><a href="#priv4">How Do You Use My Personal Data</a></li>
                                            <li><a href="#priv5">Changes to this Privacy Policy</a></li>
                                        </ul>
                                    </div>
                                    {/* <!-- Page Category List End --> */}

                                    {/* <!-- Sidebar CTA Box Start --> */}
                                    <div class="sidebar-cta-box wow fadeInUp" data-wow-delay="0.25s">
                                        {/* <!-- Sidebar CTA Image Start --> */}
                                        <div class="sidebar-cta-img">
                                            <img src="images/sidebar-cta-img.svg" alt="" />
                                        </div>
                                        {/* <!-- Sidebar CTA Image End --> */}

                                        {/* <!-- Sidebar CTA Content Start --> */}
                                        <div class="sidebar-cta-content">
                                            <h3>How Can We Help</h3>
                                            <p>Whenever you need help, our team is just a message or call away.</p>
                                        </div>
                                        {/* <!-- Sidebar CTA Content End --> */}

                                        {/* <!-- Sidebar CTA Contact Start --> */}
                                        <div class="sidebar-cta-contact">
                                            {/* <!-- Footwr Contact Item Start --> */}
                                            <div class="footer-contact-item">
                                                <div class="icon-box">
                                                    <i class="fa-solid fa-phone"></i>
                                                </div>
                                                <div class="footer-contact-content">
                                                    <p><a href="tel:+256393000417">0393000417</a></p>
                                                </div>
                                            </div>
                                            {/* <!-- Footwr Contact Item End --> */}

                                            {/* <!-- Footwr Contact Item Start --> */}
                                            <div class="footer-contact-item">
                                                <div class="icon-box">
                                                    <i class="fa-solid fa-twitter"></i>
                                                </div>
                                                <div class="footer-contact-content">
                                                    <p><a href="">@pesarates</a></p>
                                                </div>
                                            </div>
                                            <div class="footer-contact-item">
                                                <div class="icon-box">
                                                    <i class="fa-solid fa-envelope"></i>
                                                </div>
                                                <div class="footer-contact-content">
                                                    <p><a href="mailto:qubitanalytic@gmail.com">qubitanalytic@gmail.com</a></p>
                                                </div>
                                            </div>
                                            {/* <!-- Footwr Contact Item End --> */}
                                        </div>
                                        {/* <!-- Sidebar CTA Contact End --> */}
                                    </div>
                                    {/* <!-- Sidebar CTA Box End --> */}
                                </div>
                                {/* <!-- Page Single Sidebar End --> */}
                            </div>

                            <div class="col-lg-8">
                                {/* <!-- Page FAQs Catagery Start --> */}
                                <div class="page-faqs-catagery">
                                    {/* <!-- FAQs section start --> */}
                                    <div class="faq-accordion page-faq-accordion" id="priv1">
                                        <div class="section-title">
                                            <h2 class="wow fadeInUp" data-cursor="-opaque"><span style={{ WebkitBackgroundClip: 'text' }}>Background</span></h2>
                                        </div>
                                        {/* <!-- FAQ Accordion Start --> */}
                                        <div class="faq-accordion" id="accordion">
                                            {/* <!-- FAQ Item Start --> */}
                                            <div class="accordion-item wow fadeInUp" data-wow-delay="0.2s">
                                                <h2 class="accordion-header" id="heading1">
                                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapse1" aria-expanded="true" aria-controls="collapse1">
                                                    </button>
                                                </h2>
                                                <div id="collapse1" class="accordion-collapse collapse show"
                                                    aria-labelledby="heading1" data-bs-parent="#accordion">
                                                    <div class="accordion-body">
                                                        <p>

                                                            Pesa Rates understands that your privacy is important to you and that you
                                                            care about how your personal data is used. We respect and value the
                                                            privacy of everyone who visits this website or uses our application and
                                                            will only collect and use personal data in ways that are described here,
                                                            and in a way that is consistent with our obligations and your rights
                                                            under the Data Protection and Privacy Act, 2019 and Regulations.

                                                        </p>
                                                        <p>

                                                            Please read this Privacy Policy carefully and ensure that you understand
                                                            it. By using our site and, or our application, you give the affirmative
                                                            consent that you have read and accepted all the terms in this Privacy
                                                            Policy. If you do not accept and agree with this Privacy Policy, you
                                                            must stop using Our Site/application immediately.

                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!-- FAQ Item End --> */}
                                        </div>
                                        {/* <!-- FAQ Accordion End --> */}
                                    </div>
                                    {/* <!-- FAQs section End --> */}

                                    {/* <!-- FAQs section start --> */}
                                    <div class="faq-accordion page-faq-accordion" id="priv2">
                                        <div class="section-title">
                                            <h2 class="wow fadeInUp" data-cursor="-opaque"> <span style={{ WebkitBackgroundClip: 'text' }}>What Does This Policy Cover</span>
                                            </h2>
                                        </div>
                                        {/* <!-- FAQ Accordion Start --> */}
                                        <div class="faq-accordion" id="accordion1">
                                            {/* <!-- FAQ Item Start --> */}
                                            <div class="accordion-item wow fadeInUp" data-wow-delay="0.2s">
                                                <h2 class="accordion-header" id="heading6">
                                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapse6" aria-expanded="true" aria-controls="collapse6">
                                                    </button>
                                                </h2>
                                                <div id="collapse6" class="accordion-collapse collapse show"
                                                    aria-labelledby="heading6" data-bs-parent="#accordion1">
                                                    <div class="accordion-body">
                                                        <p>
                                                            This Privacy Policy applies to your use of our Site and, or application.
                                                            Please note that we have no control over how your data is collected,
                                                            stored, or used by other websites whose links may be provided on our
                                                            website and we advise you to check the privacy policies of any such
                                                            websites before providing any data to them.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!-- FAQ Item End --> */}

                                            {/* <!-- FAQ Item Start --> */}
                                            <div class="accordion-item wow fadeInUp" data-wow-delay="0.4s">
                                                <h2 class="accordion-header" id="heading7">
                                                    <button class="accordion-button collapsed" type="button"
                                                        data-bs-toggle="collapse" data-bs-target="#collapse7" aria-expanded="false"
                                                        aria-controls="collapse7">
                                                        What is Personal Data?
                                                    </button>
                                                </h2>
                                                <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
                                                    data-bs-parent="#accordion1">
                                                    <div class="accordion-body">
                                                        <p>
                                                            Personal data is defined as any information relating to an identified or
                                                            identifiable natural person (called a data subject) who can be directly
                                                            or indirectly identified in particular by reference to an identifier
                                                            such as name, an identification number, location data, an online
                                                            identifier, or to one or more factors specific to the physical,
                                                            physiological, genetic, mental, economic, cultural or social identity of
                                                            that natural person.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!-- FAQ Item End --> */}

                                            {/* <!-- FAQ Item Start --> */}
                                            <div class="accordion-item wow fadeInUp" data-wow-delay="0.6s">
                                                <h2 class="accordion-header" id="heading8">
                                                    <button class="accordion-button collapsed" type="button"
                                                        data-bs-toggle="collapse" data-bs-target="#collapse8" aria-expanded="false"
                                                        aria-controls="collapse8">
                                                        What Are My Rights?
                                                    </button>
                                                </h2>
                                                <div id="collapse8" class="accordion-collapse collapse" aria-labelledby="heading8"
                                                    data-bs-parent="#accordion1">
                                                    <div class="accordion-body">
                                                        <p>
                                                            As a data subject, you have the following rights, which we will always
                                                            work to uphold:</p>
                                                        <ol>
                                                            <li>The right to be informed about our collection and use of your
                                                                personal data. This Privacy Policy should tell you everything you
                                                                need to know, but you can always contact us to find out more or to
                                                                ask any questions.</li>

                                                            <li>The right to access the personal data we hold about you. Part 12
                                                                will tell you how to do this.</li>

                                                            <li>The right to have your personal data rectified if any of your
                                                                personal data held by us is inaccurate or incomplete. Please contact
                                                                us find out more.</li>

                                                            <li>The right to be forgotten, i.e., the right to ask us to delete or
                                                                otherwise dispose of any of your personal data that we have. Please
                                                                contact us to find out more.</li>

                                                            <li>The right to restrict (i.e., prevent) the processing of your
                                                                personal data.</li>

                                                            <li>The right to object to us using your personal data for a particular
                                                                purpose(s).</li>
                                                        </ol>
                                                        <p>For more information about our use of your personal data or exercising
                                                            your rights as outlined above, please contact us.

                                                            Further information about your rights can also be obtained from the
                                                            National Data Protection Agency.

                                                            If you have any cause for complaint about our use of your personal data,
                                                            you have the right to lodge a complaint with the Data Protection Agency.

                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!-- FAQ Item End --> */}

                                        </div>
                                        {/* <!-- FAQ Accordion End --> */}
                                    </div>
                                    {/* <!-- FAQs section End --> */}

                                    {/* <!-- FAQs section start --> */}
                                    <div class="faq-accordion page-faq-accordion" id="priv3">
                                        <div class="section-title">
                                            <h2 class="wow fadeInUp" data-cursor="-opaque"><span style={{ WebkitBackgroundClip: 'text' }}>What Data Do We Collect</span></h2>
                                        </div>
                                        {/* <!-- FAQ Accordion Start --> */}
                                        <div class="faq-accordion" id="accordion2">
                                            {/* <!-- FAQ Item Start --> */}
                                            <div class="accordion-item wow fadeInUp" data-wow-delay="0.2s">
                                                <h2 class="accordion-header" id="heading11">
                                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapse11" aria-expanded="true"
                                                        aria-controls="collapse11">
                                                    </button>
                                                </h2>
                                                <div id="collapse11" class="accordion-collapse collapse show"
                                                    aria-labelledby="heading11" data-bs-parent="#accordion2">
                                                    <div class="accordion-body">
                                                        <p><b>
                                                            Depending upon your use of our Site and, or application, we may
                                                            collect some or all of the following personal and non-personal data
                                                            including but not limited to;-</b></p>
                                                        <ol>
                                                            <li>Name;</li>

                                                            <li>Email address;</li>

                                                            <li>Telephone number;</li>

                                                            {/* <!--li>Payment information;</li--> */}

                                                        </ol>
                                                        <p><b>We use the information you give to;</b></p>
                                                        <ol>
                                                            <li>Identify you</li>

                                                            <li>Locate you</li>

                                                            <li>Find forex houses near you</li>

                                                            {/* <!--li>Link you to an approved payment system (pesa wallet)</li --> */}

                                                            <li>Improve the service such as saving common destinations</li>

                                                            <li>Connect services like “Send” and “Share” with your contacts</li>

                                                            <li>For product research development</li>

                                                            <li>To provide measurements and analytics</li>

                                                            <li>Communicate with you (share marketing communications on our
                                                                products)</li>

                                                            <li>Generally, improve your user experience.</li>
                                                        </ol>

                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!-- FAQ Item End --> */}
                                        </div>
                                        {/* <!-- FAQ Accordion End --> */}
                                    </div>
                                    {/* <!-- FAQs section End --> */}

                                    {/* <!-- FAQs section start --> */}
                                    <div class="faq-accordion page-faq-accordion" id="priv4">
                                        <div class="section-title">
                                            <h2 class="wow fadeInUp" data-cursor="-opaque"> <span style={{ WebkitBackgroundClip: 'text' }}>How Do You Use My Personal
                                                Data</span></h2>
                                        </div>
                                        {/* <!-- FAQ Accordion Start --> */}
                                        <div class="faq-accordion" id="accordion3">
                                            {/* <!-- FAQ Item Start --> */}
                                            <div class="accordion-item wow fadeInUp" data-wow-delay="0.2s">
                                                <h2 class="accordion-header" id="heading16">
                                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapse16" aria-expanded="false"
                                                        aria-controls="collapse16"></button>
                                                </h2>
                                                <div id="collapse16" class="accordion-collapse collapse show"
                                                    aria-labelledby="heading16" data-bs-parent="#accordion3">
                                                    <div class="accordion-body">
                                                        <p>
                                                            we use your data for the necessary performance of a contract with you
                                                            and because you have consented to the use of your personal data, or
                                                            because it is in our legitimate business interests to use it. Your
                                                            personal data may also be used for the following purposes:</p>
                                                        <ol>
                                                            <li>Providing and managing your Account;</li>

                                                            <li>Providing and managing your access to Our Site and, or application;
                                                            </li>
                                                            <li>Personalizing and tailoring your experience on Our Site and, or
                                                                application;</li>

                                                            <li>Supplying our services to you. Your personal details are required in
                                                                order for us to enter into a contract with you.</li>

                                                            <li>Personalizing and tailoring our services for you.</li>

                                                            <li>Communicating with you. This may include responding to emails or
                                                                calls from you.
                                                            </li>
                                                            <li>Supplying you with information that you have the option to opt-out
                                                                at any time</li>

                                                        </ol>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!-- FAQ Item End --> */}

                                            {/* <!-- FAQ Item Start --> */}
                                            <div class="accordion-item wow fadeInUp" data-wow-delay="0.2s">
                                                <h2 class="accordion-header" id="heading17">
                                                    <button class="accordion-button collapsed" type="button"
                                                        data-bs-toggle="collapse" data-bs-target="#collapse17" aria-expanded="true"
                                                        aria-controls="collapse17">
                                                        How Long Will You Keep My Personal Data?
                                                    </button>
                                                </h2>
                                                <div id="collapse17" class="accordion-collapse collapse" aria-labelledby="heading17"
                                                    data-bs-parent="#accordion3">
                                                    <div class="accordion-body">
                                                        <p>
                                                            We store data until it is no longer necessary to provide our services or
                                                            until your account is deleted - whichever comes first. This is a
                                                            case-by-case determination that depends on things like the nature of the
                                                            data, why it is collected and processed, and relevant legal or
                                                            operational retention needs in accordance with the law.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!-- FAQ Item End --> */}

                                            {/* <!-- FAQ Item Start --> */}
                                            <div class="accordion-item wow fadeInUp" data-wow-delay="0.4s">
                                                <h2 class="accordion-header" id="heading18">
                                                    <button class="accordion-button collapsed" type="button"
                                                        data-bs-toggle="collapse" data-bs-target="#collapse18" aria-expanded="false"
                                                        aria-controls="collapse18">
                                                        How Can I Control My Personal Data?
                                                    </button>
                                                </h2>
                                                <div id="collapse18" class="accordion-collapse collapse" aria-labelledby="heading18"
                                                    data-bs-parent="#accordion3">
                                                    <div class="accordion-body">
                                                        <p>
                                                            We provide you with the ability to access, rectify, port and erase your
                                                            data. To learn more, visit the settings on the App.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!-- FAQ Item End --> */}

                                            {/* <!-- FAQ Item Start --> */}
                                            <div class="accordion-item wow fadeInUp" data-wow-delay="0.6s">
                                                <h2 class="accordion-header" id="heading19">
                                                    <button class="accordion-button collapsed" type="button"
                                                        data-bs-toggle="collapse" data-bs-target="#collapse19" aria-expanded="true"
                                                        aria-controls="collapse19">
                                                        How Can I Access My Personal Data?
                                                    </button>
                                                </h2>
                                                <div id="collapse19" class="accordion-collapse collapse" aria-labelledby="heading19"
                                                    data-bs-parent="#accordion3">
                                                    <div class="accordion-body">
                                                        <p>
                                                            If you want to know what personal data we have about you, you can ask us
                                                            for details of that personal data and for a copy of it (where any such
                                                            personal data is held). This is known as a “subject access request”.
                                                        </p>
                                                        <p>
                                                            All subject access requests should be made in writing and sent to the
                                                            email or postal addresses. We do not charge for a subject access request
                                                            but if your request is ‘manifestly unfounded or excessive (for example,
                                                            if you make repetitive requests) a fee may be charged to cover our
                                                            administrative costs in responding.
                                                        </p>
                                                        <p>
                                                            We will respond to your subject access request within two weeks and, in
                                                            any case, not more than one month of receiving it. Normally, we aim to
                                                            provide a complete response, including a copy of your personal data
                                                            within that time. In some cases, however, particularly if your request
                                                            is more complex, more time may be required up to a maximum of three
                                                            months from the date we receive your request. You will be kept fully
                                                            informed of our progress.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!-- FAQ Item End --> */}
                                        </div>
                                        {/* <!-- FAQ Accordion End --> */}
                                    </div>
                                    {/* <!-- FAQs section End --> */}


                                    {/* <!-- FAQs section start --> */}
                                    <div class="faq-accordion page-faq-accordion" id="priv5">
                                        <div class="section-title">
                                            <h2 class="wow fadeInUp" data-cursor="-opaque"> <span style={{ WebkitBackgroundClip: 'text' }}>Changes to this Privacy Policy
                                            </span></h2>
                                        </div>
                                        {/* <!-- FAQ Accordion Start --> */}
                                        <div class="faq-accordion" id="accordion3">
                                            {/* <!-- FAQ Item Start --> */}
                                            <div class="accordion-item wow fadeInUp" data-wow-delay="0.2s">
                                                <h2 class="accordion-header" id="heading16">
                                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapse16" aria-expanded="false"
                                                        aria-controls="collapse16"></button>
                                                </h2>
                                                <div id="collapse16" class="accordion-collapse collapse show"
                                                    aria-labelledby="heading16" data-bs-parent="#accordion3">
                                                    <div class="accordion-body">
                                                        <p>
                                                            We may change this Privacy Policy from time to time and in some
                                                            instances without notice to you. This may be necessary, for example, if
                                                            the law changes, or we change our business in a way that affects
                                                            personal data protection.
                                                        </p>
                                                        <p>
                                                            Any changes will be immediately posted on our Site and, or application
                                                            and you will be deemed to have accepted the terms of the Privacy Policy
                                                            on your first use of our Site and, or application following the
                                                            alterations. We recommend that you check this page regularly to keep
                                                            up-to-date.
                                                        </p>
                                                        <p>
                                                            By your use of our Site and, or application, you, by affirmative action,
                                                            consent to these terms. Please do not use our Site and, or application
                                                            or services if you do not consent to these terms.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!-- FAQ Item End --> */}
                                        </div>
                                        {/* <!-- FAQ Accordion End --> */}
                                    </div>
                                    {/* <!-- FAQs section End --> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Page Faqs End --> */}


                {/* <!-- Footer Start --> */}
                <footer class="main-footer">
                    <div class="container">
                        <div class="row">
                            {/* <!-- <div class="col-lg-6 col-md-12">
                    <div class="about-footer">
                        <div class="footer-logo">
                            <img src="images/footer-logo.svg" alt="">
                        </div>
                   
                        <div class="about-footer-content">
                            <p>Your trusted partner in cybersecurity, offering cutting-edge solutions to defend against
                                evolving threats.</p>
                        </div>
                    </div>
                </div> --> */}

                            <div class="col-lg-12">
                                <div class="footer-links">
                                    <h3>quick links of reference</h3>
                                    <ul>
                                        <li><a href="https://pesarates.com" target='blank'>Pesa Rates</a></li>
                                        <li><a href="https://billing.pesarates.com" target='blank'>Pesa Rates Api</a></li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                {/* <!-- Footer Copyright Start --> */}
                                <div class="footer-copyright-text">
                                    <p>Copyright © 2025 All Rights Reserved.</p>
                                </div>
                                {/* <!-- Footer Copyright End --> */}
                            </div>
                        </div>
                    </div>
                </footer>
                {/* <!-- Footer End --> */}

            </body>



        )
    }
}
export default Home

